<template>
  <AddUser />
</template>

<script>
import AddUser from '../../../components/skillup/user/AddUserList.vue'
import appConfig from '@/app.config'

export default {
  page: {
    title: 'افزودن کاربر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-add-users',
  components: {
    AddUser,
  },
}
</script>
